import {
  useCreateEstudianteMutation,
  useEditEstudianteMutation,
  useCreateEstadoPorEstudianteMutation,
  useEditEstadoPorEstudianteMutation,
  useGetCiclosQuery,
} from "services";
import { useSnackbar } from "notistack";
import { getModifiedFields, reemplazarUrl } from "helpers/functions";

// Función que filtra los campos a excluir
const filterFields = (data, excludeFields) => {
  return Object.fromEntries(
    Object.entries(data).filter(([key, value]) => {
      if (excludeFields.includes(key)) {
        if (key === "telefonos" && Array.isArray(value) && value.length === 0) {
          return false; // Excluir el campo "telefono" si es un arreglo vacío
        }
        if (key === "groups") return false;
        return !(typeof value === "string" || value === null || value === "");
      }
      return true;
    })
  );
};

export const useStudentSubmit = (
  id,
  handleClose,
  oldValues,
  estado,
  estadoIdState,
  getEstudianteById
) => {
  const { enqueueSnackbar } = useSnackbar();
  const { data: ciclos } = useGetCiclosQuery();

  const [createEstudiante] = useCreateEstudianteMutation();
  const [editEstudiante] = useEditEstudianteMutation();
  const [createEstado] = useCreateEstadoPorEstudianteMutation();
  const [editEstado] = useEditEstadoPorEstudianteMutation();

  const handleSubmit = async (values, actions) => {
    const excludeFields = ["foto", "telefonos"];
    const excludeFieldsEditing = [
      "foto",
      "telefonos",
      "groups",
      "url_cambio_password",
    ];

    try {
      if (!id) {
        // Create Mode
        const studentData = { ...values };
        if (studentData.telefonos && studentData.telefonos.length > 0) {
          studentData.telefonos = studentData.telefonos.filter((t) => t.numero);
        }

        const data = filterFields(studentData, excludeFields);
        const cicloUrl =
          ciclos && ciclos.length > 0 ? ciclos[ciclos.length - 1].url : "";

        await createEstudiante({
          ...data,
          ciclo: cicloUrl,
        }).unwrap();

        enqueueSnackbar("Estudiante creado con éxito", { variant: "success" });
      } else {
        // Edit Mode
        const modifiedFields = getModifiedFields(oldValues, values);

        if (Object.keys(modifiedFields).length !== 0) {
          let data = filterFields(modifiedFields, excludeFieldsEditing);

          if (estado[0] && modifiedFields.estado !== undefined) {
            await editEstado({
              id: estadoIdState,
              estado: modifiedFields.estado,
            }).unwrap();
          } else if (
            modifiedFields.estado !== undefined &&
            modifiedFields.estado !== ""
          ) {
            const res = await getEstudianteById({
              id: id,
              filter_params: { query: "{url}" },
            }).unwrap();
            await createEstado({
              ciclo: ciclos[ciclos?.length - 1]?.url,
              estado: modifiedFields.estado,
              estudiante: reemplazarUrl(res?.url, 1),
            }).unwrap();
          }

          if (Object.keys(data).length !== 0) {
            await editEstudiante({
              id: id,
              ...data,
            }).unwrap();
          }
          enqueueSnackbar("Estudiante editado con éxito", {
            variant: "success",
          });
        }
      }

      actions.setSubmitting(false);
      actions.resetForm();
      handleClose();
    } catch (e) {
      console.error(e);
      actions.setSubmitting(false);
      enqueueSnackbar(
        !id ? "Error al crear estudiante" : "Error al editar estudiante",
        { variant: "error" }
      );
    }
  };

  return { handleSubmit };
};
